module.exports = __webpack_public_path__ + "img/mpesa-logo.4a6e7623.png";